import type { ForwardedRef } from 'react';

import { Image, Link, Text } from '@change/ds-core-ui';

import { forwardRef } from '@change-corgi/core/react/core';

import type { NewsAndGuidesListItem } from 'src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from 'src/app/pages/newsAndGuides/list/shared/hooks';
import { LegacyHtml as Html } from 'src/app/shared/components/html';

type Props = {
	item: NewsAndGuidesListItem;
};

export function ExpandedCardInner({ item }: Props, ref: ForwardedRef<HTMLAnchorElement>) {
	const {
		data: { categoryName, targetUrl, photoUrl },
	} = useItemCard(item);

	return (
		<Link
			href={targetUrl}
			ref={ref}
			data-qa="expanded-card-link"
			className="text-typography-strong no-underline hover:text-typography-strong [&_*]:no-underline"
		>
			<div className="relative block h-auto w-full md:flex md:h-[264px] md:items-center md:justify-end">
				<div className="absolute left-0 top-0 z-0 h-[220px] w-full md:h-full md:w-[60%] lg:w-[50%]">
					<Image
						src={photoUrl}
						fallback={
							<Image
								src="https://static.change.org/images/default-petition.gif"
								alt=""
								className="h-full w-full rounded-small object-cover"
								loading="lazy"
								role="presentation"
							/>
						}
						alt=""
						className="h-full w-full rounded-small object-cover"
						loading="lazy"
						role="presentation"
					/>
				</div>
				<div className="relative z-10 mt-[220px] w-full rounded-small bg-fill-inverse-strong py-6 pl-2 pr-2 md:mt-0 md:w-[58%] md:pl-6 md:pr-10">
					<Text as="span" fontWeight="bold" size="x-small" className="uppercase text-typography-weak">
						{categoryName}
					</Text>
					<Text as="h2" variant="heading" size="small" className="mb-6 mt-2 text-typography-strong">
						{item.title}
					</Text>
					<Html as="div" html={item.excerpt} breakWord lineClamp={[null, 3]} />
				</div>
			</div>
		</Link>
	);
}

export const ExpandedCard = forwardRef(ExpandedCardInner);
